// Swiperを設定
const productImageSwiper = new Swiper('.product-media__main', {
  slidesPerView: 1,
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

// 全てのスライダーを取得
const productMedia = document.querySelectorAll('.product-media__slider.swiper-slide');
const halfProductMedia = Array.from(productMedia).slice(0, Math.ceil(productMedia.length / 2));

// 対象画像IDをスライドに表示
const displayCurrentId = (selectImageId, smoothScroll) => {
  // 選択したカラーのスライド1枚目インデックスを取得
  let matchedSlideIndex = 0;
  productImageSwiper.forEach(swiper => {
    swiper.slides.forEach((slide, index) => {
      if (slide.dataset.imageId === selectImageId) {
        matchedSlideIndex = index;
      }
    });
  });

  // スライダーを更新し、選択したカラーの1枚目を表示する
  productImageSwiper.forEach(swiper => {
    swiper.update();
    if (smoothScroll) {
      swiper.slideTo(matchedSlideIndex);
    } else {
      swiper.slideTo(matchedSlideIndex, 0, false);
    }
  });
};

// 商品画像一覧を押した時のイベント
const productMediaAllImages = document.querySelectorAll('.product-media__all__item');
productMediaAllImages.forEach(image => {
  image.addEventListener('click', () => {
    // すでにactiveな要素からactiveクラスを削除する
    const currentActive = document.querySelectorAll('.product-section .active');
    if (currentActive) {
      currentActive.forEach(ele => {
        ele.classList.remove('active');
      });
    }

    // 現在の要素にactiveクラスを追加する
    image.classList.add('active');

    const id = image.dataset.imageId;
    // 商品画像をスライドさせる
    displayCurrentId(id, true);
  });
});

// product-image.liquidの表示のままにスライドを設定する
const initialProductMedia = () => {
  // カラーの要素を取得
  const productMediaColors = document.querySelectorAll('.product-media__colors__item');

  // 画像IDを重複無しで作成する
  const tempProductMediaColorIds = [];
  productMediaColors.forEach(productMediaColor => {
    const mediaId = productMediaColor.dataset.imageId;
    tempProductMediaColorIds.push(mediaId);
  });
  const productMediaColorIds = Array.from(new Set(tempProductMediaColorIds));

  productMediaAllImages.forEach(productMedia => {
    const mediaId = productMedia.dataset.imageId;
    if (!productMediaColorIds.includes(mediaId)) {
      productMedia.style.display = '';
    }
  });

  // スライダーのスライドを一旦削除する
  productImageSwiper.forEach(swiper => {
    swiper.removeAllSlides();
  });
  // 先にカラー画像をスライドに追加する
  productMediaColorIds.forEach(colorId => {
    productImageSwiper.forEach(swiper => {
      halfProductMedia.forEach(slide => {
        if (slide.dataset.imageId === colorId) {
          const newSlide = slide.cloneNode(true);
          swiper.appendSlide(newSlide);
        }
      });
    });
  });

  // スライドをクローンしてカラースライド以外を追加する
  productImageSwiper.forEach(swiper => {
    halfProductMedia.forEach(slide => {
      if (!productMediaColorIds.includes(slide.dataset.imageId)) {
        const newSlide = slide.cloneNode(true);
        swiper.appendSlide(newSlide);
      }
    });
  });

  // スライダーを更新し、1枚目を表示する
  productImageSwiper.forEach(swiper => {
    swiper.update();
    swiper.slideTo(0);
  });
};

// URLパラメータからカラーIDを取得
const getColorIdByUrlParam = () => {
  // URLパラメータからvariantを取得。ない場合はcolor_idとする
  const selectedVariantId = new URL(window.location.href).searchParams.get('variant');
  if (staffVariants) {
    const selectedVariant = staffVariants.find(variant => variant.id === selectedVariantId);
    return selectedVariant && selectedVariant.image_alt
      ? selectedVariant.image_alt.split(',')[1]
      : '';
  } else {
    return '';
  }
};

// 読み込み時に最初のカラーのみ絞り込む
window.addEventListener('DOMContentLoaded', () => {
  initialProductMedia();
  // URLパラメータからIDを取得
  const searchParamColorId = getColorIdByUrlParam();
  // カラーの要素を取得
  const productMediaColors = document.querySelectorAll('.product-media__colors__item');

  let targetMediaColorItemImageId = '';

  Array.from(productMediaColors).forEach(productMediaColor => {
    if (productMediaColor.dataset.color === searchParamColorId) {
      targetMediaColorItemImageId = productMediaColor.dataset.imageId;
    }
  });
  const initialId = productMediaColors[0].dataset.imageId;

  let currentColorItems;

  if (searchParamColorId) {
    displayCurrentId(targetMediaColorItemImageId, false);
    currentColorItems = document.querySelectorAll(
      `[data-image-id="${targetMediaColorItemImageId}"]`
    );
  } else {
    displayCurrentId(initialId, true);
    currentColorItems = document.querySelectorAll(`[data-image-id="${initialId}"]`);
  }

  // すでにactiveな要素からactiveクラスを削除する
  const currentActive = document.querySelectorAll('.product-section .active');
  if (currentActive) {
    currentActive.forEach(ele => {
      ele.classList.remove('active');
    });
  }

  // 選択された全てのproduct-media__colors__itemにactiveを追加
  currentColorItems.forEach(item => {
    if (item) {
      item.classList.add('active');
    }
  });

  // カラーを選択した時のイベント
  productMediaColors.forEach(color => {
    color.addEventListener('click', () => {
      // すでにactiveな要素からactiveクラスを削除する
      const currentActive = document.querySelectorAll('.product-section .active');
      if (currentActive) {
        currentActive.forEach(ele => {
          ele.classList.remove('active');
        });
      }

      // 現在の要素にactiveクラスを追加する
      color.classList.add('active');

      const selectedVariantId = color.dataset.variantId;
      const selectedImageId = color.dataset.imageId;

      // urlパラメータのvariantを更新
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selectedVariantId);
      window.history.replaceState({}, '', url);

      displayCurrentId(selectedImageId, true);
      // 一般的な要素更新関数
      function updateElements(selector, attribute, updater) {
        const elements = document.querySelectorAll(selector);
        const selectedValue = color.getAttribute(attribute);

        elements.forEach(element => {
          updater(element, selectedValue);
        });
      }

      // innerHTMLの更新用関数
      function updateInnerHTML(element, value) {
        if (value) {
          element.parentNode.classList.remove('hidden');
          element.innerHTML = value;
        } else {
          element.parentNode.classList.add('hidden');
        }
      }

      // 画像の更新用関数
      // function updateImageSource(element, value) {
      //   if (value) {
      //     element.parentNode.parentNode.classList.remove('hidden');
      //     element.src = `https://cdn.shopify.com/s/files/1/0693/8207/8776/files/${value}.jpg`;
      //   } else {
      //     element.parentNode.parentNode.classList.add('hidden');
      //   }
      // }

      // 要素の更新
      // updateElements(
      //   '.productDetail__info__materialInfo__detail.productOrigin',
      //   'data-origin',
      //   updateInnerHTML
      // );
      updateElements(
        '.productDetail__info__materialInfo__detail.productMaterial',
        'data-material',
        updateInnerHTML
      );
      // updateElements(
      //   '.productDetail__info__materialInfo__washing.productWashing',
      //   'data-washing',
      //   updateImageSource
      // );
    });
  });
});
